import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { Suspense } from "react";
import { oauthProvidersQueryOptions } from "@/app/oauth/api/get-o-auth-providers";
import { OAuthListSkeleton } from "@/app/oauth/components/oauth-list-skeleton";
import { OAuthList } from "@/app/oauth/list/list";
import { nameFilterSchema } from "@/components/custom/filters/name-filter";

const oauthSearchSchema = nameFilterSchema;

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/auth/oauth/"
)({
  validateSearch: zodValidator(oauthSearchSchema),
  component: (): React.JSX.Element => (
    <Suspense fallback={<OAuthListSkeleton />}>
      <OAuthList />
    </Suspense>
  ),
  beforeLoad: ({ context: { queryClient }, params }) => {
    queryClient.prefetchQuery(
      oauthProvidersQueryOptions({ binding: "project", scope: params })
    );
  },
});
